import { Component, Input, Output, DoCheck, OnChanges, OnInit }         from '@angular/core';
import ObjectList                                               from '../models/ObjectList';


export type compareFunction = (a: any, b: any) => number;

@Component({
    selector: 'material-dual-list',
    templateUrl: './MaterialDualListComponent.html'
})

export class MaterialDualListComponent implements OnInit
{
    static AVAILABLE_LIST_NAME = 'available';
	static CONFIRMED_LIST_NAME = 'confirmed';

	static LTR = 'left-to-right';
	static RTL = 'right-to-left';

    static DEFAULT_FORMAT = 
    {
		add             : 'Add',
		remove          : 'Remove',
		all             : 'All',
		none            : 'None',
		direction       : MaterialDualListComponent.LTR
	};

    @Input() key                = '_id';
	@Input() display: String    = 'name';
	@Input() height             = '200px';
	@Input() filter             = false;
	@Input() format             = MaterialDualListComponent.DEFAULT_FORMAT;
	@Input() sort               = false;
	@Input() compare            : compareFunction;
	@Input() disabled           : Boolean = false;
	@Input() source             : ObjectList<any>;
	@Input() destination        : ObjectList<any>;
    
    available                   : ObjectList<any>;
    confirmed                   : ObjectList<any>;
    
    available_picked            : [] = [];
    confirmed_picked            : [] = [];

	sourceDiffer                : any;
    destinationDiffer           : any;
    
    available_filter            : "";
    confirmed_filter            : "";

    private sorter = (a: any, b: any) => { return (a._name < b._name) ? -1 : ((a._name > b._name) ? 1 : 0); };
    
    constructor() 
    {
    }

    ngOnInit()
    {
        this.available              = this.source;
        this.confirmed              = this.destination;
    }

    //****************** LEFT TO RIGHT *************/
    moveFromTo()
    {
        this.confirmed.merge(this.available_picked , this.key);
        this.available.cut(this.available_picked , this.key);
        this.available.pour(this.source);
        this.confirmed.pour(this.destination);
        this.available_picked = [];
    }

    moveAllFromTo()
    {
        this.confirmed.merge(this.available.all() , this.key);
        this.available.clear();
        this.available.pour(this.source);
        this.confirmed.pour(this.destination);
        this.available_picked = [];
    }

    //****************** RIGHT TO LEFT *************/
    moveToFrom()
    {
        this.available.merge(this.confirmed_picked , this.key);
        this.confirmed.cut(this.confirmed_picked , this.key);
        this.available.pour(this.source);
        this.confirmed.pour(this.destination);
        this.confirmed_picked = [];
    }

    moveAllToFrom()
    {
        this.available.merge(this.confirmed.all() , this.key);
        this.confirmed.clear();
        this.available.pour(this.source);
        this.confirmed.pour(this.destination);
        this.confirmed_picked = [];
    }

}